const form = {
  formId: "new-user-form",
  formField: {
    taxId: {
      name: "taxId",
      label: "1 Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    conpanyName: {
      name: "conpanyName",
      label: "2 Tên đơn vị phát hành hóa đơn",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên đơn vị phát hành",
      invalidMsg: "Tên đơn vị phát hành không hợp lệ",
    },
    managingUnitTaxId: {
      name: "managingUnitTaxId",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    managingUnit: {
      name: "managingUnit",
      label: "Tên đơn vị",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên đơn vị",
    },
    otherBillType: {
      name: "otherBillType",
      label: "[3] Các loại hóa đơn khác",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
    },
    notificationReceivingAgency: {
      name: "notificationReceivingAgency",
      label: "5 Tên cơ quan thuế tiếp nhận thông báo",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên cơ quan thuế tiếp nhận thông báo ",
    },
    releaseDate: {
      name: "releaseDate",
      label: "Ngày phát hành",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập ngày phát hành",
    },
    representative: {
      name: "representative",
      label: "Người đại diện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người đại diện",
    },
  },
};

export default form;
